import React from 'react'
import { useEffect, useRef, useState } from 'react'
import { SLowcodeList, SAside } from 'shj-components'
import { message, notification, InputNumber } from 'antd'
import {
  queryMpmsSpuList,
  queryMpmsCategoryList,
  chooseSubmit,
  allSubmit,
  checkSpuAndCache,
} from '@/services/mpms.ts'
import { useUpdateEffect } from 'ahooks'
import { getBrandList } from '@/services/product.ts'
import ContentModal from './components/contentModal'
import { config } from './config/index.tsx'
import styles from './index.module.less'

export default function ChooseMaterial() {
  const [openPrintModal, setOpenPrintModal] = useState(false)
  const [chooseDiabled, setChooseDisabled] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [treeData, setTreeData] = useState<any>([])
  const [prodCateId, setProdCateId] = useState('')
  const [dataList, setDataList] = useState([])
  const [totalCount, setTotalCount] = useState(0)

  const listRef = useRef()

  useUpdateEffect(() => {
    listRef.current?.reload()
  }, [prodCateId])

  const fetchList = async values => {
    try {
      const res: any = await queryMpmsSpuList({
        ...values,
        ...values.query,
        pageId: values?.current,
        code: values?.query?.code,
        nameKeyword: values?.query?.nameKeyword,
        manuLocationKeyword: values?.query?.manuLocationKeyword,
        brandCode: values?.query?.brandCode,
        extendCatId: prodCateId,
        enabled: true,
        searchFlag: true,
        orderBys: [
          {
            columnName: 'id',
            asc: false,
          },
        ],
      })
      if (!res?.list) {
        message.error('查询列表失败')
        return
      }
      setTotalCount(res?.count)
      setDataList(res?.list)
      return {
        records: res?.list,
        total: res?.count,
      }
    } catch (err) {
      message.error('查询列表失败')
    }
  }

  // 右侧表格事件：
  const allSelect = () => {
    if (chooseDiabled) {
      setChooseDisabled(false)
      listRef?.current?.clearSelectedRowKeys()
    } else {
      setChooseDisabled(true)
      const ids: any = dataList?.map((item: any) => item.id)
      setSelectedRowKeys(ids)
    }
  }

  //   左侧树节点事件
  const onChangeType = (node: any) => {
    console.log(node)
    setProdCateId(node?.[0])
  }

  const openCategoryModal = () => {
    if (!selectedRowKeys?.length) {
      message.info('请先选择物料项')
      return
    }
    setOpenPrintModal(true)
  }

  const onSubmit = async (
    prodCatId,
    grossRate,
    specialCode = '',
    prodType,
    applyMaterialSelections
  ) => {
    try {
      if (!chooseDiabled) {
        // 选择提交
        const res: any = await chooseSubmit({
          prodCatId,
          grossRate,
          specialCode,
          prodType,
          applyMaterialSelections,
          spuIdList: [...selectedRowKeys],
        })
        if (!res.errorCode) {
          message.success('提交成功')
          setTimeout(() => {
            listRef?.current?.reload()
          }, 300)
        } else {
          message.error('提交失败')
        }
      } else {
        // 全部提交
        const searchData = listRef?.current?.getSearch()?.getFieldsValue()
        const res: any = await allSubmit({
          prodCatId,
          specialCode,
          prodType,
          extendCatId: prodCateId,
          applyMaterialSelections,
          ...searchData,
        })
        if (!res.errorCode) {
          message.success('提交成功')
          setChooseDisabled(false)
          setTimeout(() => {
            listRef?.current?.reload()
          }, 300)
        } else {
          message.error('提交失败')
        }
      }
      setOpenPrintModal(false)
    } catch (err) {
      console.log(err)
    }
  }

  const checkSubmit = async () => {
    try {
      const searchData = listRef?.current?.getSearch()?.getFieldsValue()
      const res: any = await checkSpuAndCache({
        spuIdList: [...selectedRowKeys],
        allFlag: chooseDiabled,
        extendCatId: prodCateId,
        ...searchData,
      })
      if (typeof res === 'string') {
        return res
      }
      return ''
    } catch (err) {
      console.log(err)
      return ''
    }
  }

  //   右侧下拉选项加载
  const getOptions = async () => {
    const categoryTree: any = await queryMpmsCategoryList({
      categoryLevel: 'smallCategory',
      enabled: null,
    })
    const brandList: any = await getBrandList({})
    setTreeData([{ label: '不限', id: '' }, ...categoryTree])
    return Promise.resolve({ categoryTree, brandList })
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList, getOptions },
    events: { allSelect, openCategoryModal },
    getCheckboxProps: record => ({
      disabled: chooseDiabled,
    }),
    selectedRowKeys: selectedRowKeys,
    onSelectedRowChange: (keys, rows) => {
      setSelectedRowKeys(keys)
    },
    customRender: {
      numberRender({ name, form }) {
        return (
          <InputNumber
            style={{ width: '100%' }}
            placeholder={'有效产品数'}
            onInput={v => {
              form.setFieldsValue({ [name]: v })
            }}
          />
        )
      },
    },
  }

  return (
    <div className={styles.settlementQuotaConfig}>
      <div className={styles.leftMenu}>
        {/* 左侧树形选择 */}
        <SAside
          treeData={treeData}
          onSelect={onChangeType}
          title={''}
          treeType="tree"
          defaultSelectedKeys={['0']}
          // active={state.categoryCode}
          fieldNames={{ title: 'label', key: 'id' }}
          header={false}
          dropItems={false}
        />
      </div>
      {/* 右侧数据表格 */}
      <div className={styles.rightTable}>
        <SLowcodeList
          ref={listRef}
          searchMode="group"
          config={config}
          rowSelectedTotal={chooseDiabled ? totalCount : ''}
          {...extensions}
        />
      </div>
      {openPrintModal && (
        <ContentModal
          reload={() => listRef?.current?.reload()}
          checkSubmit={checkSubmit}
          submit={async (id, grossRate, specialCode, prodType, applyMaterialSelections) =>
            await onSubmit(id, grossRate, specialCode, prodType, applyMaterialSelections)
          }
          onClose={() => setOpenPrintModal(false)}
          open={openPrintModal}
          totalCount={chooseDiabled ? totalCount : 0} 
        />
      )}
    </div>
  )
}
